// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3j-SB","balanceDisclaimer":"posDashboard_balanceDisclaimer__1456t"};